export interface BootstrapData {
  schemaVersion: number;
  env: { appEnv: string; release: string };
  csrfToken: string;
  user: Record<string, unknown> | null;
  preferences: Record<string, unknown>;
}

export const BOOTSTRAP_SCHEMA_VERSION = 1;
